export default __webpack_public_path__ + "img/homepage-mobile-zumper-rentals.218b8ad0.svg";